import { PageName, UserInfo, UserPermissions } from "./types";

const pageTitles = {
  [PageName.home.valueOf()]:               {adminTitle: "Kepler",                     externalTitle: "Kepler"},
  [PageName.overall.valueOf()]:            {adminTitle: "📊 Overall (Reporting)",     externalTitle: "Kepler - Reporting - Overall"},
  [PageName.products.valueOf()]:           {adminTitle: "📊 Products (Reporting)",    externalTitle: "Kepler - Reporting - Products"},
  [PageName.performanceReports.valueOf()]: {adminTitle: "📊 Performance (Reporting)", externalTitle: "Kepler - Reporting - Performance"},
  [PageName.trackingLinksLookup.valueOf()]:      {adminTitle: "🔗 cLinks (Campaigns)",      externalTitle: "Kepler - Campaigns"},
  [PageName.lookup.valueOf()]:     {adminTitle: "🔍 Lookup (Campaigns)",     externalTitle: "Kepler - Campaigns"},
}

export function setDocumentTitle(page:string, currentUser:UserInfo) {
  if ( !currentUser ) {
    document.title = process.env.REACT_APP_NAME;
  }
  page = page ? page : PageName.overall.valueOf();

  let title;
  let admin = currentUser.permissions.includes(UserPermissions.appptapDataFullAccess);

  if (admin) {
    title = pageTitles[page] ? pageTitles[page].adminTitle : process.env.REACT_APP_NAME;
  }
  else {
    title = pageTitles[page] ? pageTitles[page].externalTitle : process.env.REACT_APP_NAME;
  }

  if (process.env.REACT_APP_BRANCH && process.env.REACT_APP_BRANCH.length) {
    title = `${process.env.REACT_APP_BRANCH} - ${title}`;
  }

  document.title = title;
}
